/**
 * Created by h3 on 2018-10-05.
 */


export class FruitsParticleConfig {


    public static getBigWinConfig(duration:number, blendMode:string = "normal"):any {

        return {
            "alpha": {
                "start": 1,
                "end" : 0
            },
            "scale": {
                "start": 0.5,
                "end": 1.5,
                "minimumScaleMultiplier": 1.5
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start" : 100,
                "end" : 200,
                "minimumSpeedMultiplier": 5
            },
            "acceleration": {
                "x": 0,
                "y": 0
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 30,
                "max": 360
            },
            "noRotation": true,
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min" : 5,
                "max": 5
            },
            "blendMode": blendMode,
            "frequency" : 0.04,
            "emitterLifetime": duration,
            "maxParticles" : 128,
            "pos": {
                "x": 0,
                "y": 0
            },
            "addAtBack": true,
            "spawnType": "circle",
            "spawnCircle": {
                "x": 0,
                "y": 0,
                "r": 0
            }
        }

    }


}